module.exports = __webpack_public_path__ + "static/img/1216mask1.694f9a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1216mask1.png
// module id = osNU
// module chunks = 1